import { render } from "./icon-focus.vue?vue&type=template&id=7143aa16"
import script from "./icon-focus.vue?vue&type=script&lang=js"
export * from "./icon-focus.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__